module.exports = __webpack_public_path__ + "img/sistemas-bombeo (3).b77a702d.jpg";